import API from "@/api.js";
export function bottomMenu() {
	let bottomMenu = [{
			name: "AI助手",
			iconOn: require("@/ico/stutas/test/chatYes.svg"),
			iconOff: require("@/ico/stutas/test/chatNo.svg"),
			key: "chat",
			stu: true,
			tea: true
		},
		{
			name: "上传评价",
			iconOn: require("@/ico/stutas/test/uploadYes.svg"),
			iconOff: require("@/ico/stutas/test/uploadNo.svg"),
			key: "upload",
			stu: true,
			tea: false
		},
		{
			name: "我的作品",
			iconOn: require("@/ico/stutas/test/imgYes.svg"),
			iconOff: require("@/ico/stutas/test/imgNo.svg"),
			key: "workshow",
			stu: true,
			tea: false
		},
		{
			name: "全班作品",
			iconOn: require("@/ico/stutas/test/imgYes.svg"),
			iconOff: require("@/ico/stutas/test/imgNo.svg"),
			key: "classworkshow",
			stu: false,
			tea: true
		},
		{
			name: "实验测试",
			iconOn: require("@/ico/stutas/test/experimentYes.svg"),
			iconOff: require("@/ico/stutas/test/experimentNo.svg"),
			key: "experiment",
			stu: true,
			tea: true
		},
		{
			name: "网页模拟器",
			iconOn: require("@/ico/stutas/test/htmlYes.svg"),
			iconOff: require("@/ico/stutas/test/htmlNo.svg"),
			key: "htmlfile",
			stu: true,
			tea: true
		},
	]
	return bottomMenu
}
export function forHtmlFile(){
	let htmlFile={
		"title":'网页模拟器',
		"htmlList":[{
			"key":1,
			"typeId":1,
			"typeName":"",
			"src":"",
			"htmlId":"",
			"id":null
		}]
	}
	return htmlFile
}
export function forUpload() {
	let upload = {
		"headerTitle": "作品评价",
		"headerBg": "#e3f2fd",
		
		"pageBg": "#ffffff",
		"cameraIcon": "📷",
		"scoreItems": [{
				"key": 1,
				"name": "方案",
				"keyId": "",
				"modelId": "",
				"keyList":[],
				"goodScore": 85,
				"icon": "📋️"
			}, {
				"key": 2,
				"name": "设计图",
				"keyId": "",
				"modelId": "",
				"goodScore": 90,
				"keyList":[],
				"icon": "🎨️"
			},

		]
	}
	return upload
}
export function forChat() {
	let chat = {
		headerTitle: "🍅 星际种植小管家",
		headerBg: "#c5e1a5",
		"aiContentText":"我是AI小助手，你有什么需要咨询的都可以问我呦!",
		pageBg: "#fff9e6",
		topIcon1: "🌙",
		topIcon2: "🍅",
		avatarStu: "🎓",
		avatarAi: "🍅",
		avatarTea: "📝",
		bubbleSelf: "#c5e1a5",
		bubbleOther: "#ffffff",
		modelId: '',
		keyId: "",
		chatFily:[],
	}
	return chat
}
export function forExperiment() {
	let experiment = {
		headerTitle: "🌕月球种植",
		headerBg: "#c5e1a5",
		pageBg: "rgba(242,255,190,0.92)",
		title: "🌕 月球基地 · 番茄农场",
		bg: "rgba(242, 255, 190, 0.92)",
		tip: "🤔 思考番茄需要什么环境？开启合适设备！",
	}
	return experiment
}
export function defaultConfigs() {
	let defaultConfig = {

	}
	defaultConfig.bottomMenu = bottomMenu()
	defaultConfig.upload = forUpload()
	defaultConfig.chat = forChat()
	defaultConfig.experiment = forExperiment()
	defaultConfig.htmlFile=forHtmlFile()
	return defaultConfig
}
export async function getModelWithoutKey(id) {
	try {
		let res = await API.get(API.admin.getModelWithoutKey + id)
		let arr = res.data.data
		let quesArr={
			isQuest:false,
			msg:"密钥过期",
			providerCode:'',
		}
		const now = new Date()
		if(arr){
			const expire = new Date(arr.expireTime)
			if(expire.getTime() < now.getTime()||arr.status==1||arr.isDeleted!=0){
				
			}else{
				quesArr.isQuest=true
				quesArr.msg="密钥正常"
				quesArr.providerCode=arr.providerCode
			}
		}
		return quesArr
	} catch {
		return {
			isQuest: false,
			msg: '请求失败'
		}
	}
}